import { Icon } from '@chakra-ui/icon';
export const RTMeIcon = props => {
  const css = `
    .st0 {
      fill: #FFFFFF;
    }
  `;
  return <Icon viewBox="0 0 40 40" {...props} data-sentry-element="Icon" data-sentry-component="RTMeIcon" data-sentry-source-file="RTMeIcon.tsx">
      <g data-sentry-element="g" data-sentry-source-file="RTMeIcon.tsx">
        <g data-sentry-element="g" data-sentry-source-file="RTMeIcon.tsx">
          <g data-sentry-element="g" data-sentry-source-file="RTMeIcon.tsx">
            <path className="st0" d="M31.7,17.9h0.7l1.4,2.6h0l1.4-2.6H36v4.3h-0.7v-2.9h0l-1.2,2h-0.5l-1.2-2h0v2.9h-0.7L31.7,17.9L31.7,17.9z" data-sentry-element="path" data-sentry-source-file="RTMeIcon.tsx" />
            <path className="st0" d="M37.2,17.9h2.7v0.6h-2v1.2h1.6v0.6h-1.6v1.1H40v0.6h-2.8V17.9z" data-sentry-element="path" data-sentry-source-file="RTMeIcon.tsx" />
          </g>
        </g>
        <g data-sentry-element="g" data-sentry-source-file="RTMeIcon.tsx">
          <path className="st0" d="M13.1,17.3c-0.1-0.1-0.2-0.2-0.4-0.2H7.9H3.1c-0.2,0-0.4,0.1-0.5,0.4l-1.3,4.8L0,27.1c0,0.1,0,0.3,0.1,0.4
            c0.1,0.1,0.2,0.2,0.4,0.2h4.8c0.2,0,0.4-0.1,0.4-0.4L7,22.9h4.5c0.2,0,0.4-0.1,0.4-0.4l1.3-4.9C13.3,17.6,13.2,17.4,13.1,17.3z
            M3.4,18h3.9l-1,3.9H2.4L3.4,18z M5,26.8H1.1l1.1-3.9H6L5,26.8z M11.1,22H7.2l1-3.9h3.9L11.1,22z" data-sentry-element="path" data-sentry-source-file="RTMeIcon.tsx" />
          <path className="st0" d="M25.5,17.1h-4.2l1.1-4.3c0-0.1,0-0.3-0.1-0.4s-0.2-0.2-0.4-0.2h-4.9c-0.2,0-0.4,0.1-0.5,0.4l-1.3,4.9
            c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h4.2L19,22h-4.5c-0.2,0-0.4,0.1-0.4,0.4l-1.3,4.9c0,0.1,0,0.3,0.1,0.4
            c0.1,0.1,0.2,0.2,0.4,0.2h4.8c0.2,0,0.4-0.1,0.5-0.4l1.2-4.5h4.5c0.2,0,0.4-0.1,0.5-0.4l1.3-4.9c0-0.1,0-0.3-0.1-0.4
            C25.8,17.2,25.7,17.1,25.5,17.1z M17.5,13.2h3.9l-1,3.9h-3.9L17.5,13.2z M17.7,26.8h-3.9l1.1-3.9h3.9L17.7,26.8z M23.9,22H20
            l1-3.9h3.9L23.9,22z" data-sentry-element="path" data-sentry-source-file="RTMeIcon.tsx" />
        </g>
      </g>

      <defs data-sentry-element="defs" data-sentry-source-file="RTMeIcon.tsx">
        <style>{css}</style>
      </defs>
    </Icon>;
};
RTMeIcon.displayName = 'RTMeIcon';